module.exports = __webpack_public_path__ + "static/media/options-spanish.c385097e.png";